import { useEffect } from 'react';

import { useOrganizationId } from '@apps/web/hooks/use_organization_id';
import { updateAppNotificationContext } from '@apps/web/lib/app_notifications';
import { useMode } from '@apps/web/lib/mode_store';
import { useNotificationPreferences } from '@apps/web/swr_data_fetching/data_fetching_hooks';

export function AppNotificationBridge() {
    const organizationId = useOrganizationId();
    const mode = useMode();
    const { data: notificationPreferences } = useNotificationPreferences(
        organizationId,
        'app-notification-bridge',
    );

    useEffect(
        () =>
            updateAppNotificationContext({
                mode,
                notificationPreferences,
                organizationId,
            }),
        [mode, notificationPreferences, organizationId],
    );

    return null;
}
